var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStaffManagerHover(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Staff_Manager_-_Second",
    "data-name": "Staff Manager - Second",
    xmlns: "http://www.w3.org/2000/svg",
    width: 79,
    height: 79,
    viewBox: "0 0 79 79",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_132995",
    "data-name": "Path 132995",
    d: "M78.107,222.92v-1.45a5.643,5.643,0,0,1-4.905-3.919,13.253,13.253,0,0,1-1.261,1.163,12.682,12.682,0,0,1-7.941,2.8v1.411a7.054,7.054,0,1,0,14.107,0Zm0,0",
    transform: "translate(-52.714 -179.188)",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_132996",
    "data-name": "Path 132996",
    d: "M0,432H79v2.821H0Zm0,0",
    transform: "translate(0 -355.821)",
    fill: "#fff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_132997",
    "data-name": "Path 132997",
    d: "M88.521,302.025A9.815,9.815,0,0,1,85.7,301.6v1.834a1.4,1.4,0,0,1-.493,1.048l3.314,2.761,3.314-2.759a1.4,1.4,0,0,1-.493-1.05V301.6a9.813,9.813,0,0,1-2.821.423Zm0,0",
    transform: "translate(-70.182 -248.417)",
    fill: "#fff"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_132998",
    "data-name": "Path 132998",
    d: "M44.7,160H32v7.054a4.214,4.214,0,0,0,3.17,4.091,3.793,3.793,0,0,0,1.062.141h1.411a9.85,9.85,0,0,0,6.168-2.17,10.335,10.335,0,0,0,1.732-1.78l.847-1.129a1.41,1.41,0,0,1,1.128-.564,1.341,1.341,0,0,1,.282.028,1.412,1.412,0,0,1,1.088,1.042l.606,2.441a2.831,2.831,0,0,0,2.735,2.132h.931v-2.821A8.473,8.473,0,0,0,44.7,160Zm0,0",
    transform: "translate(-26.357 -131.786)",
    fill: "#fff"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Path_132999",
    "data-name": "Path 132999",
    d: "M0,340.033H4.232V332.98H7.054v7.054H29.625V332.98h2.821v7.054h4.232v-7.646a7.091,7.091,0,0,0-5.2-6.808l-6.65-1.81-5.586,4.655a1.412,1.412,0,0,1-1.806,0L11.85,323.77,5.2,325.58A7.087,7.087,0,0,0,0,332.387Zm0,0",
    transform: "translate(0 -266.676)",
    fill: "#fff"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Path_133000",
    "data-name": "Path 133000",
    d: "M314.8,22.571a1.411,1.411,0,0,0,1.411-1.411V1.411A1.411,1.411,0,0,0,314.8,0H289.411A1.411,1.411,0,0,0,288,1.411V2.821h21.161a4.232,4.232,0,0,1,4.232,4.232V22.571Zm0,0",
    transform: "translate(-237.214)",
    fill: "#fff"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Path_133001",
    "data-name": "Path 133001",
    d: "M256,33.411v1.411h28.214V33.411A1.411,1.411,0,0,0,282.8,32H257.411A1.411,1.411,0,0,0,256,33.411Zm0,0",
    transform: "translate(-210.857 -26.357)",
    fill: "#fff"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "Path_133002",
    "data-name": "Path 133002",
    d: "M257.411,80.929H282.8a1.411,1.411,0,0,0,1.411-1.411V64H256V79.518A1.411,1.411,0,0,0,257.411,80.929Zm16.929-11.286h2.821v2.821h-2.821Zm-5.643,0h2.821v2.821H268.7Zm-5.643,0h2.821v2.821h-2.821Zm0,0",
    transform: "translate(-210.857 -52.714)",
    fill: "#fff"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "Path_133003",
    "data-name": "Path 133003",
    d: "M32,16h5.643v2.821H32Zm0,0",
    transform: "translate(-26.357 -13.179)",
    fill: "#fff"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    id: "Path_133004",
    "data-name": "Path 133004",
    d: "M80,16H96.929v2.821H80Zm0,0",
    transform: "translate(-65.893 -13.179)",
    fill: "#fff"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    id: "Path_133005",
    "data-name": "Path 133005",
    d: "M40,80h5.643v2.821H40Zm0,0",
    transform: "translate(-32.946 -65.893)",
    fill: "#fff"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    id: "Path_133006",
    "data-name": "Path 133006",
    d: "M88,80h16.929v2.821H88Zm0,0",
    transform: "translate(-72.482 -65.893)",
    fill: "#fff"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    id: "Path_133007",
    "data-name": "Path 133007",
    d: "M48,48h5.643v2.821H48Zm0,0",
    transform: "translate(-39.536 -39.536)",
    fill: "#fff"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    id: "Path_133008",
    "data-name": "Path 133008",
    d: "M96,48h16.929v2.821H96Zm0,0",
    transform: "translate(-79.071 -39.536)",
    fill: "#fff"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    id: "Path_133009",
    "data-name": "Path 133009",
    d: "M307.286,312h-2.821v15.518H296v2.821h19.75v-2.821h-8.464Zm0,0",
    transform: "translate(-243.804 -256.982)",
    fill: "#fff"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    id: "Path_133010",
    "data-name": "Path 133010",
    d: "M288.446,240H257.411A1.411,1.411,0,0,0,256,241.411V259.75a1.411,1.411,0,0,0,1.411,1.411H268.7v-9.875a1.411,1.411,0,0,1,1.411-1.411h5.643a1.411,1.411,0,0,1,1.411,1.411v9.875h11.286a1.411,1.411,0,0,0,1.411-1.411V241.411A1.411,1.411,0,0,0,288.446,240Zm0,0",
    transform: "translate(-210.857 -197.679)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStaffManagerHover);
export default __webpack_public_path__ + "static/media/StaffManagerHover.d5a7d8ac54a8191c8d7407307f5150ee.svg";
export { ForwardRef as ReactComponent };